// src/AdminPanel.js

import React, { useState, useEffect } from 'react';
import { db } from './App'; // Importa a instância 'db' do seu App.js
import { collection, addDoc, onSnapshot, orderBy, query, serverTimestamp, doc, deleteDoc } from 'firebase/firestore';

// Componente para formatar a data de forma legível
const formatUpdateDate = (timestamp) => {
    if (!timestamp) return 'Carregando...';
    return new Date(timestamp.seconds * 1000).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    });
};

const AdminPanel = ({ characterData }) => {
    const [updates, setUpdates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Efeito para buscar as atualizações em tempo real
    useEffect(() => {
        const q = query(collection(db, 'updates'), orderBy('createdAt', 'desc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const updatesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setUpdates(updatesData);
            setLoading(false);
        });

        return () => unsubscribe(); // Limpa o listener ao desmontar
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!title.trim() || !content.trim()) {
            alert('Título e Conteúdo são obrigatórios.');
            return;
        }
        setIsSubmitting(true);
        try {
            await addDoc(collection(db, 'updates'), {
                title,
                content,
                author: characterData.name,
                createdAt: serverTimestamp()
            });
            setTitle('');
            setContent('');
        } catch (error) {
            console.error("Erro ao adicionar atualização: ", error);
            alert('Falha ao publicar. Verifique o console e suas regras de segurança.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDelete = async (updateId) => {
        if (window.confirm('Tem certeza que deseja apagar esta atualização?')) {
            try {
                await deleteDoc(doc(db, 'updates', updateId));
            } catch (error) {
                console.error("Erro ao deletar atualização: ", error);
                alert('Falha ao deletar.');
            }
        }
    };

    return (
        <div className="text-white p-4 md:p-8">
            <h1 className="text-4xl font-bold text-stone-300 mb-6 text-center border-b-2 border-stone-700 pb-4 mu-text-shadow">
                Painel de Administração
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Formulário de Nova Atualização */}
                <div className="mu-panel p-6">
                    <h2 className="text-2xl font-bold mb-4 mu-title">Publicar Nova Atualização</h2>
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Título da Atualização (Ex: v2.5.5)"
                            className="mu-input w-full p-2 mb-4"
                        />
                        <textarea
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            placeholder="Descreva as mudanças. Você pode usar '*' para listas."
                            rows="8"
                            className="mu-input w-full p-2 mb-4 resize-none"
                        />
                        <button type="submit" className="mu-button w-full" disabled={isSubmitting}>
                            {isSubmitting ? 'Publicando...' : 'Publicar'}
                        </button>
                    </form>
                </div>

                {/* Lista de Atualizações Publicadas */}
                <div className="mu-panel p-6">
                    <h2 className="text-2xl font-bold mb-4 mu-title">Atualizações Recentes</h2>
                    <div className="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
                        {loading ? <p>Carregando...</p> : updates.map(update => (
                            <div key={update.id} className="bg-stone-900/60 p-3 rounded-md border border-stone-700">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <p className="font-bold text-yellow-300">{update.title}</p>
                                        <p className="text-xs text-stone-400">
                                            Publicado em {formatUpdateDate(update.createdAt)}
                                        </p>
                                    </div>
                                    <button onClick={() => handleDelete(update.id)} className="mu-button-small bg-red-800/80">
                                        Apagar
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPanel;